// import { httpClient } from "@/app/shared/services";

import { apiConstants } from "../../config";
import { apiPost } from "../../../../shared/services";

const registerUser = async (data, validator) => {
  let url = apiConstants.register;
  return await apiPost(url, { ...data }, validator);
};

export { registerUser };
